import type { StakePolicyResponse } from '@gamble-chess/contracts';
import type { JSX } from 'react';

import { describeTier } from '../format.ts';
import { focusRingClass, hintClass } from '../ui/styles.ts';

/** The bands the server applies to a scaled stake, in words; nothing for a fixed stake. */
export function TierExplanation({
  policy,
}: {
  readonly policy: StakePolicyResponse;
}): JSX.Element | null {
  if (policy.tiers.length === 0) {
    return null;
  }
  return (
    <details className={hintClass}>
      <summary className={`w-fit cursor-pointer rounded-xs ${focusRingClass}`}>
        How the rating gap scales it
      </summary>
      <ul className="mt-1 list-disc pl-5">
        {policy.tiers.map((tier) => (
          <li key={tier.multiplier}>{describeTier(tier)}</li>
        ))}
      </ul>
    </details>
  );
}
